export default {
  en: {
    'transfer_to_x': 'transfer to {name}',
    'x_price_money': '{price} price money',
    'x_rank': '{rank}. rank',
    'from_to_rank': '{from} - {to} rank',
    'finals': 'finals',
    'semifinals': 'semifinals',
    'quarterfinals': 'quarterfinals',
    'first_leg': 'first_leg',
    'second_leg': 'second_leg',
    'show_promotions_and_delegation_rules': 'promotion and delegations rules',
    'finished': 'finished',
    'division': 'division',
    'points': 'points',
    'promotions': 'promotions',
    'competitions': 'competitions',
    'reward_for_division_name': 'reward for {name}',
    'select_division': 'select division',
    'extra_time_short': 'a.e.t.',
    'penalty_time_short': 'a.pen.',
    'player_suspended_for_x_matches': '{player} suspended for {matches} matches in {competition}.',
    'table': 'table',
    'no_matches_scheduled': 'No matches scheduled.',
    'divisions': 'divisions',
    'player_stats': 'player stats',
    '': '',
  }
};